import { render } from "./CpfPopup.vue?vue&type=template&id=0e857806&scoped=true"
import script from "./CpfPopup.vue?vue&type=script&lang=js"
export * from "./CpfPopup.vue?vue&type=script&lang=js"

import "./CpfPopup.vue?vue&type=style&index=0&id=0e857806&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e857806"]])

export default __exports__